/* KUP Manifesto — the word barrel.

   Behaviours beyond spinning:

   1. It rests on the first word ("KUP") rather than drifting. The barrel is
      reset on load and again every time the section re-enters the viewport, so
      the brand word is what a visitor finds when they arrive or scroll back.
      A spin the visitor started is left alone until they leave and return.

   2. While untouched and on screen it rocks: every few seconds it eases up a
      few words and back down to rest. Rocking uses a raised cosine, so it
      starts and ends at exactly zero velocity and always lands back on "KUP".
      The hint stops for good once the visitor spins it themselves.

   SPACING
   Rows are positioned linearly — one row height between every pair, at every
   position on the barrel. The original used y = unit * sin(a), which models a
   real drum: the two words either side of centre sat ~79px apart while the
   next pair sat ~65px and the pair beyond ~40px. Physically faithful, but it
   reads as a spacing mistake rather than as perspective, and the gap around
   the highlighted word looked oversized. Depth is now carried by the scale and
   opacity falloff alone, which still curve away from centre. */
(function(){
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(vp){
    if(!vp || vp.dataset.kupWheelBound === '1') return;
    vp.dataset.kupWheelBound = '1';

    var stage = vp.querySelector('.kup-wheel-stage');
    if(!stage) return;
    var items = [].slice.call(stage.querySelectorAll('.kup-wheel-item'));
    var n = items.length;
    if(!n) return;

    var live = document.getElementById('kupWheelLive');
    var sec  = vp.closest('section') || vp;

    var STEP = 0.42, CUTOFF = 1.45, MAX_SPEED = 5;
    var HINT_ON     = !RM && vp.getAttribute('data-hint') !== 'false';
    var HINT_EVERY  = parseFloat(vp.getAttribute('data-hint-every'))  || 4.5;
    var HINT_TRAVEL = parseFloat(vp.getAttribute('data-hint-travel')) || 3.5;
    var HINT_DUR    = 1.5;

    var rot = 0, speed = 0, lastCentered = -1;
    var dragging = false, engaged = false, inView = false;
    var idleT = 0, hintP = null;
    var lastY = 0, lastT = 0, activePointer = null;

    function wrap(d){ return d - n * Math.round(d / n); }
    function buzz(){ if('vibrate' in navigator){ try{ navigator.vibrate(7); }catch(e){} } }
    function rowHeight(){
      var h = items[0].getBoundingClientRect().height;
      if(!h) h = parseFloat(getComputedStyle(items[0]).fontSize) * 1.55;
      return h || 40;
    }

    function render(){
      var fh = rowHeight();
      var unit = fh / STEP;
      for(var i = 0; i < n; i++){
        var item = items[i];
        var a = wrap(i - rot) * STEP;
        var abs = Math.abs(a);
        if(abs > CUTOFF){ item.style.opacity = '0'; item.style.pointerEvents = 'none'; continue; }
        /* Linear: a/STEP rows from centre, times one row height. */
        var y = unit * a;
        var scale = Math.cos(a); if(scale < 0) scale = 0;
        scale = 0.5 + 0.5 * scale;
        var t = abs / CUTOFF;
        item.style.opacity = Math.pow(1 - t, 1.7).toFixed(3);
        item.style.pointerEvents = 'auto';
        item.style.color = abs < STEP * 0.5 ? 'var(--kup-orange)' : 'rgba(232,232,232,' + (0.8 - t * 0.55).toFixed(2) + ')';
        item.style.fontWeight = abs < STEP * 0.5 ? '700' : '600';
        item.style.transform = 'translateY(-50%) translateY(' + y.toFixed(2) + 'px) scale(' + scale.toFixed(3) + ')';
      }
      var centered = ((Math.round(rot) % n) + n) % n;
      if(centered !== lastCentered){
        lastCentered = centered;
        if(live) live.textContent = 'Coffee is ' + items[centered].textContent;
        if(engaged || dragging) buzz();
      }
    }

    function reset(){
      rot = 0; speed = 0; engaged = false; hintP = null; idleT = 0;
      render();
    }

    function frame(now){
      var last = frame._last || now;
      var dt = Math.min(0.05, (now - last) / 1000);
      frame._last = now;

      if(!dragging){
        if(hintP !== null){
          hintP += dt / HINT_DUR;
          if(hintP >= 1){ hintP = null; rot = 0; idleT = 0; }
          else{
            /* Raised cosine: zero velocity at both ends, peak at the middle. */
            rot = HINT_TRAVEL * (1 - Math.cos(2 * Math.PI * hintP)) / 2;
          }
        } else {
          rot += speed * dt;
          speed += (0 - speed) * Math.min(1, dt * 1.4);
          if(HINT_ON && !engaged && inView && Math.abs(speed) < 0.02){
            idleT += dt;
            if(idleT >= HINT_EVERY){ hintP = 0; }
          }
        }
      }

      render();
      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);

    function engage(){ engaged = true; hintP = null; idleT = 0; }

    vp.addEventListener('pointerdown', function(e){
      engage();
      dragging = true; activePointer = e.pointerId;
      lastY = e.clientY; lastT = performance.now();
      vp.style.cursor = 'grabbing';
      try{ vp.setPointerCapture(e.pointerId); }catch(err){}
    });
    vp.addEventListener('pointermove', function(e){
      if(!dragging || (activePointer != null && e.pointerId !== activePointer)) return;
      var now = performance.now();
      var dt = Math.max(1, now - lastT);
      var fh = rowHeight();
      var dy = e.clientY - lastY;
      rot -= dy / fh;
      speed = (-dy / fh) / (dt / 1000);
      if(speed > MAX_SPEED) speed = MAX_SPEED; else if(speed < -MAX_SPEED) speed = -MAX_SPEED;
      lastY = e.clientY; lastT = now;
    });
    function endDrag(){
      if(!dragging) return;
      dragging = false; activePointer = null; vp.style.cursor = 'grab';
    }
    vp.addEventListener('pointerup', endDrag);
    vp.addEventListener('pointercancel', endDrag);
    vp.addEventListener('pointerleave', endDrag);
    window.addEventListener('blur', endDrag);

    vp.addEventListener('touchmove', function(e){ e.preventDefault(); }, {passive:false});
    vp.addEventListener('wheel', function(e){
      e.preventDefault();
      engage();
      speed += (e.deltaY > 0 ? 1 : -1) * 0.9;
      if(speed > MAX_SPEED) speed = MAX_SPEED; else if(speed < -MAX_SPEED) speed = -MAX_SPEED;
    }, {passive:false});
    vp.addEventListener('keydown', function(e){
      if(e.key === 'ArrowDown'){ e.preventDefault(); engage(); speed = Math.min(MAX_SPEED, speed + 1.5); }
      if(e.key === 'ArrowUp'){ e.preventDefault(); engage(); speed = Math.max(-MAX_SPEED, speed - 1.5); }
    });

    /* Reset on every re-entry, not just the first. */
    if(window.IntersectionObserver){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          var was = inView;
          inView = en.isIntersecting;
          if(inView && !was) reset();
        });
      }, {threshold: 0.25}).observe(sec);
    } else {
      inView = true;
    }

    reset();
  }

  function boot(){
    var vps = document.querySelectorAll('[data-kup-wheel]');
    for(var i = 0; i < vps.length; i++) init(vps[i]);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
